@if (document$ | async; as document) {
  <icz-transactions [type]="TransactionHistoryType.ENTITY"
                    [entityId]="document.id"
                    [esslObjectType]="EsslObjectType.DOCUMENT"
                    [identifier]="document.uid?.identifier"
                    [idSource]="document.uid?.idSource"
                    class="grow">
  </icz-transactions>
}
